import httpClient from '@/app/utils/axios';
import { Result } from '@/app/api/models/baseModel';

interface LoginResult<T = any> extends Result<T> {
    redirect_url?: string;
}

// 학급 정보 확인
export function checkClassroom<T = any>(data: { code: string }) {
    // 2. axios.post(url, data, config) 형식에 맞춥니다.
    return httpClient.post<Result<T>>(route('app.login.check.classroom'), data, {
        // errorCallback을 params 안이 아닌, config 객체 바로 아래에 위치시킵니다.
        errorCallback: (error) => {},
    });
}

// 해시로 학급 정보 확인
export function getClassroomByHash<T = any>(data: { classroom_code_hash: string }) {
    return httpClient.post<Result<T>>(route('app.login.check.classroom.hash'), data, {
        errorCallback: (error) => {},
    });
}

// 학생 정보 확인
export function checkStudent<T = any>(data: {
    classroom_id: number;
    classroom_number: string;
    name: string;
    classroom_code_hash: string;
}) {
    return httpClient.post<Result<T>>(route('app.login.check.student'), data, {
        errorCallback: (error) => {},
    });
}

// PIN 번호 확인 및 로그인
export function checkPinAndLogin<T = any>(data: {
    classroom_id: number;
    student_id: number;
    pin: string;
    classroom_code_hash: string;
}) {
    return httpClient.post<LoginResult<T>>(route('app.login.check.pin'), data, {
        errorCallback: (error) => {},
    });
}
